type Window = {
  env?: Env;
  location: any;
};

type Paths = Record<string, Path>;

type Path = {
  local: string;
  remote: string;
};

type Env = 'dev' | 'prod';

type PathKey = keyof Path;

declare var window: Window;

const subdomain = window.location.host.split('.')[0];

const baseUrl = 'https://prod.cdni.callofduty.com/prelogin/';

const location: PathKey = window.env ? 'local' : 'remote';

const env: Env = process.env.NODE_ENV === 'development' || subdomain === 'dev' ? 'dev' : window.env || 'prod';

const paths: Paths = {
  splash: {
    local: 'media/img/splash.jpg',
    remote: `${baseUrl}media/img/splash.jpg`,
  },
  menu_cod_logo_lg: {
    local: 'media/img/menu_cod_logo_lg.png',
    remote: `${baseUrl}media/img/menu_cod_logo_lg.png`,
  },
  wzm_logo: {
    local: 'media/img/wzm-logo.png',
    remote: `${baseUrl}media/img/wzm-logo.png`,
  },
  video_cdni: {
    local: 'media/video/wzm-cinematic.mp4',
    remote: `${baseUrl}media/video/wzm-cinematic.mp4`,
  },
  video_login: {
    local: 'media/video/loop.mp4',
    remote: `${baseUrl}media/video/loop.mp4`,
  },
  bg_general: {
    local: 'media/img/bg_general.jpg',
    remote: `${baseUrl}media/img/bg_general.jpg`,
  },
};

export const getPath = (key: string) => {
  return paths[key][config.location];
};

const config = {
  acceptanceUrl: `https://${env}.cdni.callofduty.com/prelogin/data/pre-login-status.%LOCALE%.json`,
  location,
  paths,
  env,
};

export default config;
